## `components/CourseList.vue`
<template>
    <div class="course-equivalent-list">
        <div class="course-equivalent" v-for="(course, i) in courses" :key="course.id || i">
            <span class="course-name-span">
                {{ course.full_name || (course.code && course.name ? `${course.code} - ${course.name}` : course.name) }}
            </span>
            <a class="remove" @click="$emit('remove', i)">
                <i class="fa-solid fa-xmark"></i>
                Remove
            </a>
        </div>
    </div>
</template>
<script setup lang="ts">
import type Course from '@/models/course';

defineProps<{ courses: Course[] }>();
</script>